import { TextareaFenceUtil } from '@axiom/ui';

import type { ChatAnswerSegment } from '../types/chat-answer.types';

import { ChatEmailUtil } from './chat-email-util';

/* Two tags for one thing: the model reaches for `mermaid` unprompted, `flowchart` is our own. */
const FLOWCHART_LANGUAGES = new Set(['flowchart', 'mermaid']);

const DRAWN_LANGUAGES = new Set(['email', ...FLOWCHART_LANGUAGES]);

export const ChatAnswerUtil = {
  /** Asked by language as a fence opens, then about its body once it closes. */
  isDrawn({ code, language }: { code: string; language: string }) {
    if (!DRAWN_LANGUAGES.has(language)) return false;

    if (!code || FLOWCHART_LANGUAGES.has(language)) return true;

    return ChatEmailUtil.hasVisibleFields({
      email: ChatEmailUtil.parseEmail({ text: code }),
    });
  },

  /** The same split the editor draws from, in the shape the copy path reads back. */
  parseAnswer({ text }: { text: string }): ChatAnswerSegment[] {
    return TextareaFenceUtil.split({
      isDrawn: ChatAnswerUtil.isDrawn,
      text,
    }).map(segment => {
      if (segment.type === 'text') return segment;

      return FLOWCHART_LANGUAGES.has(segment.language)
        ? {
            code: segment.code,
            /* One key for both tags: to a reader they are the same kind of block. */
            key: segment.key.replace(/^mermaid-/, 'flowchart-'),
            type: 'flowchart' as const,
          }
        : {
            email: ChatEmailUtil.parseEmail({ text: segment.code }),
            key: segment.key,
            type: 'email' as const,
          };
    });
  },
};
